<template>
  <app-dialog :value="value" title="Quittung drucken" :max-width="440" blur nested @input="$emit('input', $event)">
    <div class="rlh">
      <p class="rlh__intro">Mit welchem Briefkopf?</p>
      <ul class="rlh__list" aria-label="Briefköpfe">
        <li v-for="choice in choices" :key="choice.key">
          <button type="button" class="rlh__row" @click="$emit('choose', choice)">
            <span class="rlh__tile" aria-hidden="true"><app-icon name="briefcase" :size="16" /></span>
            <span class="rlh__text">
              <span class="rlh__name">{{ choice.letterhead.name }}</span>
              <span v-if="choice.letterhead.url" class="rlh__url">{{ choice.letterhead.url }}</span>
            </span>
            <app-icon name="printer" :size="14" class="rlh__print" />
          </button>
        </li>
      </ul>
    </div>
    <template v-slot:actions>
      <app-button @click="$emit('input', false)">Abbrechen</app-button>
    </template>
  </app-dialog>
</template>

<script>
// Auswahl des Briefkopfs vor dem Druck einer Quittung (Kundenwunsch 20.10.2026: in einem Mandanten fahren zwei Betriebe,
// src/components/payments/receiptLetterheads.js). Liste wie „Mandant wechseln“ (AppTenantSwitch): ein Klick auf einen
// Briefkopf druckt sofort, keine Vorauswahl und nichts gemerkt, damit nicht versehentlich der falsche Betrieb auf der
// Quittung steht. Props: value, choices [{ key, letterhead { name, url, tel }, logo }]. Ereignisse: input, choose.
export default {
  name: 'ReceiptLetterheadDialog',
  props: {
    value: { type: Boolean, default: false },
    choices: { type: Array, default: () => [] }
  }
};
</script>

<style scoped>
.rlh {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.rlh__intro {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--ink-2);
}
.rlh__list {
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--line);
  border-radius: var(--r-ctl);
}
.rlh__row {
  width: 100%;
  min-height: 52px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 6px 12px 6px 8px;
  border: 0;
  border-bottom: 1px solid var(--line-2);
  background: transparent;
  color: var(--ink);
  font-family: var(--font);
  text-align: left;
  cursor: pointer;
}
.rlh__list li:last-child .rlh__row {
  border-bottom: 0;
}
:where(html:not(.dichte-touch)) .rlh__row:hover {
  background: var(--band);
}
.rlh__row:active {
  background: var(--tint);
}
.rlh__row:focus {
  outline: none;
}
.rlh__row:focus-visible {
  box-shadow: inset 0 0 0 2px var(--link);
}
html.dichte-touch .rlh__row {
  min-height: 56px;
}
.rlh__tile {
  width: 24px;
  height: 24px;
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--r-ctl);
  background: var(--tile);
  color: var(--tile-fg);
}
.rlh__text {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.rlh__name,
.rlh__url {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rlh__name {
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
}
.rlh__url {
  font-size: 12px;
  line-height: 16px;
  color: var(--ink-3);
}
.rlh__print {
  flex: none;
  color: var(--ink-3);
}
</style>
